var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    { attrs: { modalId: "downgrade-unavailable-modal", size: "modal-md" } },
    [
      _c(
        "ModalHeader",
        {
          attrs: {
            title: _vm.$t("xUnableToDowngrade"),
            icon: "fas fa-exclamation-triangle colorOrange"
          }
        },
        [
          _c("div", { staticClass: "float-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-icon-button btn-icon-button--gray",
                attrs: {
                  type: "button",
                  "data-test-hook": "x-button-downgrade-unavailable-modal"
                },
                on: {
                  click: function($event) {
                    return _vm.closeDowngradeUnavailableModal()
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" })]
            )
          ])
        ]
      ),
      _c("ModalBody", [
        _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.$t("xMustRemoveProductsToDowngrade")))])
        ]),
        _c("div", { staticClass: "mt-4" }, [
          _c("strong", [_vm._v(_vm._s(_vm.getProductName(_vm.singleGen)))]),
          _c("p", { staticClass: "mt-1" }, [
            _vm._v(_vm._s(_vm.$t("xSingleGeneratorMaxProducts")))
          ])
        ]),
        _c("div", { staticClass: "mt-4" }, [
          _c("strong", [_vm._v(_vm._s(_vm.getProductName(_vm.singleTank)))]),
          _c("p", { staticClass: "mt-1" }, [
            _vm._v(_vm._s(_vm.$t("xSingleFuelMonitorMaxProducts")))
          ])
        ]),
        _c("div", { staticClass: "mt-4" }, [
          _c("strong", [_vm._v(_vm._s(_vm.getProductName(_vm.singleHome)))]),
          _c("p", { staticClass: "mt-1" }, [
            _vm._v(_vm._s(_vm.$t("xPremiumMonitoringMaxProducts")))
          ])
        ]),
        _c("div", { staticClass: "mt-4" }, [
          _c("strong", [_vm._v(_vm._s(_vm.getProductName(_vm.multiHome)))]),
          _c("p", { staticClass: "mt-1" }, [
            _vm._v(_vm._s(_vm.$t("xPremiumMultiHomeMaxProducts")))
          ])
        ])
      ]),
      _c("ModalFooter", [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-warning flex flex-grow-1",
            attrs: {
              "data-test-hook": "cancel-button-downgrade-unavailable-modal"
            },
            on: {
              click: function($event) {
                return _vm.closeDowngradeUnavailableModal()
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("xCancel")) + " ")]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-warning flex flex-grow-1",
            attrs: {
              "data-test-hook":
                "remove--products-button-downgrade-unavailable-modal"
            },
            on: {
              click: function($event) {
                return _vm.goToRemoveProducts()
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("xRemoveProductsButtonText")) + " ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }